import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { TEditAchievement } from './types'
import { $params } from '../../../../features/router'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const achievementMounted = createEvent()

export const setAchievement = createEvent<TEditAchievement>()

export const submitUpdateAchievement = createEvent<TEditAchievement>()

export const resetUpdateAchievementDone = createEvent()

export const $achievement = restore(setAchievement, {
  name: '',
  imagePath: '',
  file: '',
  priority: '',
  isDisabled: false,
  enabledAt: ''
})

export const updateAchievement = fx<TEditAchievement, TEditAchievement>({
  method: 'POST',
  url: '/achievement',
})

export const getAchievement = fx<void, TEditAchievement>({
  method: 'GET',
  url: '/achievement/',
})

export const $updateAchievementDone = restore(
  updateAchievement.done.map(() => true),
  false,
).reset(resetUpdateAchievementDone)

sample({
  clock: achievementMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.achievementID
    }
    return {
      url: `/achievement/${id}`,
    }
  },
  target: getAchievement,
})

sample({
  clock: submitUpdateAchievement,
  source: $params,
  fn: (params, achievement) => {
    let id = params ? params.achievementID : ''
    return {
      url: `/achievement/${id}`,
      formData: { ...achievement },
    }
  },
  target: updateAchievement,
})

sample({
  clock: [getAchievement.doneData, updateAchievement.doneData],
  fn: (doneData) => doneData.body,
  target: [setAchievement],
})

sample({
  clock: updateAchievement.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: updateAchievement.failData,
  fn: (failData) => ({
    message: failData.body?.message ?? 'Error',
    code: failData.status,
  }),
  target: setRequestError,
})
